<template>
    <div class="home-teacher-content">
        <!-- Header -->
        <div class="container-fluid ind-head">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-sm-3 home-logo">
                        <a href="/"><img :src="$t('logo_home')"></a>
                        <div class="ind-slogan-home">{{ $t('header_slogan') }}</div>
                    </div>
                  <div class="col-sm-6 home-ceneter-menu align-self-center order-3 order-sm-2">
                    <div class="row">
                      <div class="col-sm mgtop-0">
                        <a href="https://poliglotiki.com/instrukciya-po-obuchenie-na-onlajn-platforme.html" class="topmenu-home">Инструкция по обучению</a>
                        <div class="dop"><a href="" class="topmenu-home">{{ $t('additional_formats') }}</a>
                          <ul class="dopformat">
                            <li><a href="/hometeacher.html">{{ $t('home_teacher') }}</a></li>
                            <li><a href="/home-teacher/onlineteacher">{{ $t('online_teacher') }}</a></li>
                            <li><a href="/home-teacher/individual">{{ $t('individual_lessons') }}</a></li>
                          </ul></div>
                        <a href="https://poliglotiki.com/home-teacher/exams" class="topmenu-home">{{ $t('tests') }}</a>
                        <br>
                        <a href="/about.html">{{ $t('about') }}</a>
                        <a href="https://www.poliglotiki.ru/index_all" target="_blank">{{ $t('full_time_lessons') }}</a>
                        <!--<div class="divstartfree"><a href="/home-teacher/try-free" class="startfree">Начать бесплатно</a></div> -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm home-main-title">
                        <div class="ind-h1">{{ $t('header_title') }}</div>
                      </div>

                    </div>

                  </div>
                    <div class="col-sm-3 home-right-menu order-2 order-sm-3">
                        <div class="row">

                            <div class="col-sm home-main-faq">
                                <a href="/faq.html" class="faq-a">{{ $t('ask_a_question') }}</a>
                                <a href="/"><img src="@/assets/hometeacher/images/ru.png"></a>
                                <a href="https://poliglotiki.com/eng/"><img src="@/assets/hometeacher/images/en.png"></a>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <div class="wttg">
                                    <a target="_blank" title="Telegram" rel="nofollow" href="https://t.me/PoliglotikiHomeTeacherBot"><img src="@/assets/hometeacher/images/tlg-small.png"></a>
                                    <a target="_blank" title="WhatsApp" rel="nofollow" href="https://wa.me/78127751401"><img src="@/assets/hometeacher/images/wa-small.png"></a>
                                    <div class="tlf"><a :href="`tel:${$t('support_phone')}`" style="margin-left: 7px;">{{ $t('support_phone') }}</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-sm text-right" v-if="user">
                                <base-dropdown class="nav-item" position="right">
                                    <a slot="title" class="nav-link p-0" href="javascript:void(0);" role="button">
                                        <div class="media align-items-center">
                                            <i class="fa fa-chevron-down mr-2"></i>
                                            <span class="rounded-circle">
                                            <img src="poliimg/ic_user_top.png" />
                                        </span>
                                        </div>
                                    </a>

                                    <div class=" dropdown-header noti-title">
                                        <h6 class="text-overflow m-0" v-if="user.email">{{ user.email }}</h6>
                                        <h6 class="text-overflow m-0" v-else-if="user.phone">{{ user.phone }}</h6>
                                    </div>

                                    <router-link to="/user/profile" class="dropdown-item">
                                        <i class="ni ni-single-02"></i>
                                        <span>{{ $t('my_profile') }}</span>
                                    </router-link>

                                    <div class="dropdown-divider"></div>
                                    <router-link to="/user/logout" class="dropdown-item">
                                        <i class="ni ni-user-run"></i>
                                        <span>{{ $t('logout') }}</span>
                                    </router-link>
                                </base-dropdown>
                            </div>
                            <div class="col-sm ind-home-reg" v-else>
                                <router-link to="/user/signin">{{ $t('login') }}</router-link>
                                /
                                <router-link to="/user/signin">{{ $t('register') }}</router-link>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mobile-vers">
                    <div class="col-12 mobile-reg mgbt-ind">
                        <div class="mobile-en">
                            <a href="https://poliglotiki.com/eng/">EN</a>
                        </div>
                        <div class="mobile-ru">
                            <a href="javascript:void(0);">RU</a>
                        </div>
                        <div class="mobile-faq">
                            <div class="tlf-mobile">
                                <img src="@/assets/hometeacher/images/tlf-mobile.png">
                                <div class="galniz"></div>
                                <div class="contact">
                                    <a :href="`tel:${$t('support_phone')}`" style="margin-left: 7px;">{{ $t('support_phone') }}</a>
                                    <a v-if="$t('wa_link')"  target="_blank" title="WhatsApp" rel="nofollow" :href="$t('wa_link')"><img src="@/assets/hometeacher/images/wa-top.png" class="miniw"></a>
                                    <a v-if="$t('tg_link')"  target="_blank" title="Telegram" rel="nofollow" :href="$t('tg_link')"><img src="@/assets/hometeacher/images/tlg-top.png" class="miniw"></a>
                                </div>
                            </div>

                            <div class="faq-mobile">
                                <a href="/faq.html"><img src="@/assets/hometeacher/images/faq-home.png"></a>
                            </div>

                        </div>
                        <div class="mobile-registr">
                            <router-link to="/user/profile" v-if="user">{{ $t('account') }}</router-link>
                            <router-link to="/user/signin" v-else>{{ $t('login') }}/{{ $t('register') }}</router-link>
                        </div>

                        <div class="logo-mobile">
                            <a href="/"><img :src="$t('logo_home')" class="mobile-logo"></a>
                            <div class="slogan-home slogan-mobile">{{ $t('header_slogan') }}</div>
                        </div>
                        <input type="checkbox" id="btn-menu" />
                        <label for="btn-menu"><img src="@/assets/hometeacher/images/menu-mobile.png" class="menu-mobile"></label>
                        <ul class="list-menu">
                            <li><a href="/godovoj-kurs-anglijskogo-yazyka.html">{{ $t('english_lang') }}</a></li>
                            <li><a href="/godovoj-kurs-anglijskij-s-rozhdeniya.html">{{ $t('anglomies') }}Англомамы</a></li>
                            <li><a href="/godovoj-kurs-ispanskogo-yazyka.html">{{ $t('spanish_lang') }}</a></li>
                            <li><a href="/godovoj-kurs-francuzskogo-yazyka.html">{{ $t('french_lang') }}</a></li>
                            <li><a href="/godovoj-kurs-nemeckogo-yazyka.html">{{ $t('german_lang') }}</a></li>
                            <li><a href="/godovoj-kurs-kitajskogo-yazyka.html">{{ $t('chinese_lang') }}</a></li>
                            <li><a href="/godovoj-kurs-skorochteniya.html">{{ $t('speed_reading') }}</a></li>
                            <li><a href="/polugodovoj-kurs-mnemotexnika.html">{{ $t('mnemonics') }}</a></li>
                            <li><a href="/kompleksnyj-kurs-po-podgotovke-k-shkole.html">Подготовка к школе</a></li>
                            <li><a href="/hometeacher.html">{{ $t('home_teacher') }}</a></li>
                            <li><a href="/home-teacher/onlineteacher">{{ $t('online_teacher') }}</a></li>
                            <li><a href="/home-teacher/individual">{{ $t('individual_lessons') }}</a></li>
                            <li><a href="/home-teacher/exams">{{ $t('tests') }}</a></li>
                            <li><a href="https://www.poliglotiki.ru/index_all">{{ $t('full_time_lessons') }}</a></li>
                            <li><a href="/delimsya-sekretami.html">{{ $t('sharing_secrets') }}</a></li>
                            <li><a href="/about.html">{{ $t('about') }}</a></li>
                        </ul>


                    </div>

                    <div class="col-sm mobile-zan-head">{{ $t('header_title_mob') }}</div>
                    <div class="divstartfree"><a href="/home-teacher/try-free" class="startfree">{{ $t('try_free') }}</a></div>

                </div>
            </div>
        </div>


        <!-- Page content -->
        <router-view></router-view>

        <!-- Footer -->
        <div class="container-fluid home-footer">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <a href="/"><img src="@/assets/hometeacher/images/hometeacher-footer.png" class="onlineteacher-logo"></a>
                    </div>
                    <div class="col-12 col-sm-9 desktop-footer">
                        <div class="row">
                            <div class="col-sm home-footer-menu">
                                <a href="/hometeacher.html" class="topmenu-home">{{ $t('home_teacher') }}</a>
                               <!-- <router-link to="/onlineteacher" class="topmenu-home">OnlineTeacher</router-link>-->
                              <a href="https://www.poliglotiki.ru/index_all" class="topmenu-home">{{ $t('full_time_lessons') }}</a>
                              <div class="wttgfoot">
                                <a v-if="$t('tg_link')"  target="_blank" title="Telegram" rel="nofollow" :href="$t('tg_link')"><img src="@/assets/hometeacher/images/telegram.png"></a>
                                <a v-if="$t('wa_link')"  target="_blank" title="WhatsApp" rel="nofollow" :href="$t('wa_link')"><img src="@/assets/hometeacher/images/whatsapp.png"></a>
                              </div>
                            </div>
                        </div>
                        <div class="row home-lang">
                            <router-link to="courses?lang=1">{{ $t('english') }}</router-link>
                            <router-link to="courses?lang=4">{{ $t('french') }}</router-link>
                            <router-link to="courses?lang=3">{{ $t('german') }}</router-link>
                            <router-link to="courses?lang=2">{{ $t('spanish') }}</router-link>
                            <router-link to="courses?lang=5">{{ $t('chinese') }}</router-link>
                            <router-link to="courses?lang=6">{{ $t('russian') }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="row mobile-vers">
                    <div class="col-12 mobile-footer-reg">


                        <div class="mobile-choose">
                            <a href="/"><span class="biga">HOME</span>Teacher</a>
                            <div class="mobile-blue"><router-link to="/onlineteacher"><span
                                    class="biga">ONLINE</span>Teacher</router-link></div>

                        </div>
                        <div class="mobile-footer-menu">
                            <p>
                                <router-link to="courses?lang=1">{{ $t('english') }}</router-link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <router-link to="courses?lang=2">{{ $t('spanish') }}</router-link>
                                <br>
                                <router-link to="courses?lang=4">{{ $t('french') }}</router-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <router-link to="courses?lang=5">{{ $t('chinese') }}</router-link>
                                <br>
                                <router-link to="courses?lang=3">{{ $t('german') }}</router-link>&nbsp;&nbsp;&nbsp;
                                <router-link to="courses?lang=6">{{ $t('russian') }}</router-link>&nbsp;
                            </p>

                            <p>
                                <router-link to="courses?age=1">{{ $t('preschooler') }}</router-link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <router-link to="courses?age=2">{{ $t('schoolboy_1_4_class') }}</router-link>&nbsp;&nbsp;&nbsp;
                                <router-link to="courses?age=3">{{ $t('parent') }}</router-link>
                            </p>

                            <p><a href="https://www.poliglotiki.ru/index_all" class="topmenu-home">{{ $t('full_time_lessons') }}</a></p>
                            <p><a href="/delimsya-sekretami.html" class="about">{{ $t('articles') }}</a></p>
                            <p style="margin-bottom:20px;"><a href="/about.html" class="about">{{ $t('about') }}</a></p>
                            <p><a href="/polzovatelskoe-soglashenie.html" class="about">{{ $t('terms_of_use') }}</a></p>
                          <div class="wttgfoot">
                            <a v-if="$t('tg_link')" target="_blank" title="Telegram" rel="nofollow" :href="$t('tg_link')"><img src="@/assets/hometeacher/images/telegram.png"></a>
                            <a v-if="$t('wa_link')" target="_blank" title="WhatsApp" rel="nofollow" :href="$t('wa_link')"><img src="@/assets/hometeacher/images/whatsapp.png"></a>
                          </div>
                            <div class="socseti">
                                <a v-if="$t('yt_link')" :href="$t('yt_link')" target="_blank" rel="nofollow" class="ytb"></a>
                                <a v-if="$t('inst_link')" :href="$t('inst_link')" target="_blank" rel="nofollow" class="insta"></a>
                                <a v-if="$t('vk_link')" :href="$t('vk_link')" target="_blank" rel="nofollow" class="vk"></a>
                                <a v-if="$t('ok_link')" :href="$t('ok_link')" target="_blank" rel="nofollow" class="ok"></a>
                                <a v-if="$t('tg_link')" :href="$t('tg_link')" target="_blank" rel="nofollow" class="tg"></a>
                            </div>
                            <div style="margin-top: 10px;">
                            <img src="@/assets/hometeacher/images/history-dp.png">
                            <img src="@/assets/hometeacher/images/toprbk50.png">
                            <img src="@/assets/hometeacher/images/history-forbs.png">
                            </div>
                            <p style="margin-bottom:20px;"><router-link to="/entry" class="obratniy">{{ $t('callback') }}</router-link></p>
                        </div>
                    </div>


                </div>
                <div class="row desktop-footer">
                    <div class="col-12 col-sm-3">
                        <div class="socseti">
                            <a v-if="$t('yt_link')" :href="$t('yt_link')" target="_blank" rel="nofollow" class="ytb"></a>
                            <a v-if="$t('inst_link')" :href="$t('inst_link')" target="_blank" rel="nofollow" class="insta"></a>
                            <a v-if="$t('vk_link')" :href="$t('vk_link')" target="_blank" rel="nofollow" class="vk"></a>
                            <a v-if="$t('ok_link')" :href="$t('ok_link')" target="_blank" rel="nofollow" class="ok"></a>
                            <a v-if="$t('tg_link')" :href="$t('tg_link')" target="_blank" rel="nofollow" class="tg"></a>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">

                        <div class="row home-lang">
                            <router-link to="courses?age=1">{{ $t('preschooler') }}</router-link>&nbsp;&nbsp;&nbsp;&nbsp;
                            <router-link to="courses?age=2">{{ $t('schoolboy_1_4_class') }}</router-link>&nbsp;&nbsp;&nbsp;
                            <router-link to="courses?age=3">{{ $t('parent') }}</router-link>
                        </div>
                        <div class="row home-lang">
                            <a href="/about.html" class="about">{{ $t('about') }}</a>	<a href="/polzovatelskoe-soglashenie.html" class="about">{{ $t('terms_of_use') }}</a>
                            <a href="/delimsya-sekretami.html" class="about">{{ $t('articles') }}</a>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3 medal">
                        <img src="@/assets/hometeacher/images/history-dp.png">
                        <img src="@/assets/hometeacher/images/toprbk50.png">
                        <img src="@/assets/hometeacher/images/history-forbs.png">
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid footer-last">
            <div class="container align-middle">
                <div class="row">

                    <div class="col-12 col-lg-9 fl-copyright">
                        <div class="fl-copyright-wrap"><span class="strong-black">© {{ $t('start_year_copy') }}{{year}}
                            {{ $t('POLIGLOTIKI') }}</span> - {{ $t('footer_slogan') }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 fl-counters">
                        <router-link to="/entry">{{ $t('callback') }}</router-link>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <div class="callback-click"
             style="position: fixed;left: 10px;bottom: 10px;border-radius: 50%;padding: 10px;background-color: #ffffffa3;">
            <a href="/home-teacher/entry" title="Обратный звонок"><img src="@/assets/poliglotiki/images/callback2.gif"
                                               style="width: 100px;"></a>
        </div>
        -->

    </div>
</template>

<style src="@/assets/hometeacher/css/main.css">
</style>
<script>

    import {getUser} from "../data/jwt.service";

    export default {
        name: 'site-layout',
        data() {
            return {
                year: new Date().getFullYear(),
                showMenu: false,
                user: null,
            }
        },
        mounted() {
            this.user = getUser()
        }
    }
</script>
<style>
</style>
